import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {  Form, Input, message, Button, Select ,Empty, Pagination} from "antd";

import "./nujobsFavJobsSearchResults.scss";

import {
  SUPPORTED_LOCATION,
  SUPPORTED_JOB_CATEGORY,
} from "../../../helper/categoryconstants";
import useSettingstore from "../../../store/settings.store";
import JobListingSearchResultFilter from "../../../landing/nujobs/jobListingSearchResultFilter";
import JobListingSearchResultCards from "../../../landing/nujobs/jobListingSearchResultCards";
import useNuJobsStore from "../../../store/nujobs.store";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import NuJobsSignedInFooter from "../nuJobsSignedInFooter";

export default function NuJobsFavJobsSearchResults({}) {
  const {
    totalOpenJds,
    lastJDsReq,
    currentSearch,
    currentPageInfo,
    setCurrentPageInfo,
    myJds,
  } = useNuJobsStore();

  const { nujobGetMyFavJobs,FavJobs,totalFavCount,FavResponseMetadata,nujobsApplyNow } = useNuJobDetailsStore();   
  const { searchMetaData,setSearchMetaData } = useNuJobsStore();
  const [showFilters, setShowFilters] = useState(false);
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterJson, setFilterJson] = useState({})
  const navigate = useNavigate();

  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
  }   
  const encodeJson = (page, pageSize) =>{
        let encodedJsonValues ={};
        encodedJsonValues.keywords= "";
        encodedJsonValues.city=null;
        encodedJsonValues.category=null;  
        encodedJsonValues.timestamp= 0;  
        encodedJsonValues.postingdate= "All"
        encodedJsonValues.pagenum= page;
        encodedJsonValues.maxPerPage= pageSize;

        //from values
        encodedJsonValues.minexp=null;
        encodedJsonValues.maxexp=null;  
        encodedJsonValues.minctc= null;  
        encodedJsonValues.maxctc= null
        encodedJsonValues.noticeperiod= []; 
        encodedJsonValues.postingdate=[];
        encodedJsonValues.workmode=null;  
        encodedJsonValues.diversity= null;  
        encodedJsonValues.role= []
        encodedJsonValues.roletype= []
        encodedJsonValues.companytype= null
        encodedJsonValues.jobfor= null      
        const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
        encodedJsonValues.nujuid= userData.nujuid   
        encodedJsonValues.nujoid= userData.nujoid
        encodedJsonValues.signedin= true
        encodedJsonValues.pendingsync = JSON.parse(
                    localStorage.getItem("NuJobsPendingSync") || "[]"
            );                
                                              
        return encodedJsonValues
    }
  
  useEffect(() => {
    const jasonValues = encodeJson(currentPage, pageSize)
    nujobGetMyFavJobs(jasonValues,setSearchMetaData)
  }, []); 

  const applyNowCallBackLoggedIn = async (selectedJD) => {
    try {
      let encodedJsonValues ={};
      //now override keyword and location
      encodedJsonValues.qhoid= selectedJD.QhOID;
      encodedJsonValues.qhcompanyjid=selectedJD.QhCompanyJID;
      encodedJsonValues.companyname=selectedJD.CompanyName;  
      await nujobsApplyNow(0, encodedJsonValues);
    } catch (err) {
      alert("Application failed. Please try again.");
      return err;
    }
  };

  const handlePageChange = (page, pageSize) => {
    //console.log("Page:", page, "PageSize:", pageSize, "Current Search:", currentSearch);
    setCurrentPage(page);
    setPageSize(pageSize);
    const jasonValues = encodeJson(page, pageSize)    
    nujobGetMyFavJobs(jasonValues,setSearchMetaData)
  };

  return (
    <div className="jobListingFavJobsSearchResults-wrapper">
      <h5 style={{textAlign:"center"}}>Saved Jobs</h5>
       <Pagination
              style={{
                marginTop: "4px",
                display: "flex",
                justifyContent: "center",
                marginTop: "16px",
                marginBottom: "10px",
                
              }}
              current={currentPage}
              pageSize={pageSize}
              total={totalFavCount}
              onChange={(page, pageSize) => {
              handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
      />    
       <div className="jobListing-Results">
          <Button
            className="mobile-filter-button"
            onClick={() => setShowFilters(prev => !prev)}
          >
            {showFilters ? "Hide Filters" : "Show Filters"}
          </Button>

          <div className={`jobListing-filters ${showFilters ? "filters-visible" : ""}`}>
            <JobListingSearchResultFilter
              currentPageNumber={currentPage}
              maxPerPage={pageSize}
              filterJsonCallback={setFilterJson}
              skillCallback={FavJobs}
              isFavPage={true}
              loggedIn= {true}
            />
          </div>            
          <div className="jobListing-cards">
              <div className="job-listing-result-nums">
                 Resulting <span style={{color : "#008fff"}}>{totalFavCount?totalFavCount:0} </span> jobs saved by you
              </div>

              {FavJobs?.length > 0 ? (
              <>
                {FavJobs?.map((jd, idx) => (
                    <JobListingSearchResultCards alreadyApplied = {null} 
                                                 source = {"fav"}
                                                 openJd={jd}
                                                 idx={idx}
                                                 loggedIn= {true}
                                                 applyNowCallBackLoggedIn = {applyNowCallBackLoggedIn}
                                                 currentPage = {currentPage}/>
                ))}
              </>
              ) : (
                <Empty style={{ margin: "60px" }} />
              )}               
          </div>
       </div>  
       <Pagination
              style={{
                marginTop: "4px",
                display: "flex",
                justifyContent: "center",
                marginTop: "16px",
                marginBottom: "10px",
              }}
              current={currentPage}
              pageSize={pageSize}
              total={totalFavCount}
              onChange={(page, pageSize) => {
                handlePageChange(page, pageSize);
                
              }}
              showSizeChanger
              pageSizeOptions={[10, 20, 50, 100, 150]}
      /> 
    
     <NuJobsSignedInFooter/>                
    </div>
  );
}
